<template>
 <div :class="windowClass">
    <v-row no-gutters>
            <v-col xs="12" class="pa-2">
                

                    <v-card class="pa-2">
                        <v-card-title>
                           <v-icon large left color="secondary">mdi-truck</v-icon> MANAGE FISHCARS  
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                        ></v-text-field>
                        <v-icon right color="success" class="mt-5 ml-10" large @click="fishcar={}, state='new', form=true">mdi-plus-box</v-icon> 
                        </v-card-title>
                             <v-data-table
                                class="va-table"
                                dense
                                :headers="headers"
                                :items-per-page="25"
                                :search="search"
                                :items="Fishcars"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                            <td>
                                            <v-icon small left color="warning" @click="fishcar=item, state='update', form=true">mdi-pencil</v-icon> 
                                            {{ item.name }}</td>
                                            <td>
                                            {{$IsNum(item.commission)}}
                                            </td>
                                            <td>
                                                {{ item.contact_no }}
                                            </td>
                                            <td>
                                                {{ item.address }}
                                            </td>
                                    </tr>
                                    </tbody>
                                </template>
                          </v-data-table>
                    </v-card>
            </v-col>
    </v-row>
    <va-fishcar-form :show="form" :fishcar="fishcar" :state="state" @DialogEvent="formEvent" />
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        form: false,
        state: 'new',
        fishcar: {},
        search:'',
        Fishcars:[],
        headers: [
            { text: 'Name', value: 'name', width:'170px'},
            { text: '(%)Comm'},
            { text: 'Contact No.'},
            { text: 'Address', value: 'address'},
        ]
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.getFishcars()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      formEvent(data){
          this.form = false
          if(data.action != 'close') {
              this.fishcar = data.fishcar
              this.Save()
          }
      },
      getFishcars: function() {
        this.$http.post("supplier/list", {}).then(response => {
              response.data.data != null?this.Fishcars = response.data.data:this.Fishcars=[]
          }).catch(e => {
           console.log(e.data)
         })
     },
      Save: function() {
        let method = 'supplier/new'
        this.state != 'new'?method='supplier/update':method = 'supplier/new'
        this.$http.post(method, JSON.stringify(this.fishcar)).then(response => {
            response.data.status? this.setAlertColor('success'): this.setAlertColor('error')
            this.setAlertText(response.data.message)
            this.setAlert(true)
            this.getFishcars()
        }).catch(e => {
        console.log(e)
        })
     },
    }
  }
</script>